export const decideDesignType = (CAPI) => {
    if (CAPI.designType === 'Immersive')
        return 'Article';
    if (CAPI.designType === 'SpecialReport')
        return 'Article';
    return CAPI.designType;
};
